var map = {
	"./404-en.svg": 808,
	"./404.svg": 807,
	"./add.svg": 2082,
	"./add_to_coupon.png": 2083,
	"./age.svg": 2084,
	"./angle-double-up.svg": 2085,
	"./arrow-down.svg": 283,
	"./arrow-up.svg": 284,
	"./arrow_datapicker.png": 834,
	"./back.svg": 469,
	"./banner-bironex-logo.svg": 2086,
	"./banner-gradient.png": 835,
	"./banner-img.png": 836,
	"./banner-opx-mob.svg": 2087,
	"./banner-pattern.png": 837,
	"./banner-percent.png": 838,
	"./banner.jpg": 2088,
	"./banner.png": 2089,
	"./banner_bg.jpg": 2090,
	"./banner_two.svg": 2091,
	"./calendar-caret-down.svg": 839,
	"./chat-icon.svg": 470,
	"./checked.svg": 285,
	"./clear-betslip.svg": 2092,
	"./clear.svg": 286,
	"./close.svg": 485,
	"./corner-dark.svg": 840,
	"./corner.svg": 471,
	"./country-flags/AD.svg": 2093,
	"./country-flags/AE.svg": 2094,
	"./country-flags/AF.svg": 2095,
	"./country-flags/AG.svg": 2096,
	"./country-flags/AI.svg": 2097,
	"./country-flags/AM.svg": 2098,
	"./country-flags/AO.svg": 2099,
	"./country-flags/AR.svg": 2100,
	"./country-flags/AS.svg": 2101,
	"./country-flags/AT.svg": 2102,
	"./country-flags/AU.svg": 2103,
	"./country-flags/AW.svg": 2104,
	"./country-flags/AZ.svg": 2105,
	"./country-flags/BA.svg": 2106,
	"./country-flags/BB.svg": 2107,
	"./country-flags/BD.svg": 2108,
	"./country-flags/BE.svg": 2109,
	"./country-flags/BF.svg": 2110,
	"./country-flags/BG.svg": 2111,
	"./country-flags/BH.svg": 2112,
	"./country-flags/BI.svg": 2113,
	"./country-flags/BJ.svg": 2114,
	"./country-flags/BM.svg": 2115,
	"./country-flags/BN.svg": 2116,
	"./country-flags/BO.svg": 2117,
	"./country-flags/BR.svg": 2118,
	"./country-flags/BS.svg": 2119,
	"./country-flags/BT.svg": 2120,
	"./country-flags/BW.svg": 2121,
	"./country-flags/BY.svg": 2122,
	"./country-flags/BZ.svg": 2123,
	"./country-flags/CA.svg": 2124,
	"./country-flags/CC.svg": 2125,
	"./country-flags/CF.svg": 2126,
	"./country-flags/CG.svg": 2127,
	"./country-flags/CI.svg": 2128,
	"./country-flags/CK.svg": 2129,
	"./country-flags/CL.svg": 2130,
	"./country-flags/CM.svg": 2131,
	"./country-flags/CO.svg": 2132,
	"./country-flags/CR.svg": 2133,
	"./country-flags/CU.svg": 2134,
	"./country-flags/CV.svg": 2135,
	"./country-flags/CX.svg": 2136,
	"./country-flags/CZ.svg": 2137,
	"./country-flags/DE.svg": 2138,
	"./country-flags/DJ.svg": 2139,
	"./country-flags/DM.svg": 2140,
	"./country-flags/DO.svg": 2141,
	"./country-flags/DZ.svg": 2142,
	"./country-flags/EC.svg": 2143,
	"./country-flags/EE.svg": 2144,
	"./country-flags/EG.svg": 2145,
	"./country-flags/EH.svg": 2146,
	"./country-flags/ER.svg": 2147,
	"./country-flags/ES.svg": 2148,
	"./country-flags/FI.svg": 2149,
	"./country-flags/FJ.svg": 2150,
	"./country-flags/FK.svg": 2151,
	"./country-flags/FM.svg": 2152,
	"./country-flags/FO.svg": 2153,
	"./country-flags/GA.svg": 2154,
	"./country-flags/GB.svg": 2155,
	"./country-flags/GD.svg": 2156,
	"./country-flags/GH.svg": 2157,
	"./country-flags/GL.svg": 2158,
	"./country-flags/GM.svg": 2159,
	"./country-flags/GN.svg": 2160,
	"./country-flags/GP.svg": 2161,
	"./country-flags/GQ.svg": 2162,
	"./country-flags/GT.svg": 2163,
	"./country-flags/GU.svg": 2164,
	"./country-flags/GW.svg": 2165,
	"./country-flags/GY.svg": 2166,
	"./country-flags/HN.svg": 2167,
	"./country-flags/HT.svg": 2168,
	"./country-flags/HU.svg": 2169,
	"./country-flags/ID.svg": 2170,
	"./country-flags/IE.svg": 2171,
	"./country-flags/IL.svg": 2172,
	"./country-flags/IN.svg": 2173,
	"./country-flags/IO.svg": 2174,
	"./country-flags/IQ.svg": 2175,
	"./country-flags/IR.svg": 2176,
	"./country-flags/IS.svg": 2177,
	"./country-flags/IT.svg": 2178,
	"./country-flags/JM.svg": 2179,
	"./country-flags/JO.svg": 2180,
	"./country-flags/JP.svg": 2181,
	"./country-flags/KE.svg": 2182,
	"./country-flags/KG.svg": 2183,
	"./country-flags/KH.svg": 2184,
	"./country-flags/KI.svg": 2185,
	"./country-flags/KM.svg": 2186,
	"./country-flags/KN.svg": 2187,
	"./country-flags/KP.svg": 2188,
	"./country-flags/KR.svg": 2189,
	"./country-flags/KW.svg": 2190,
	"./country-flags/KY.svg": 2191,
	"./country-flags/KZ.svg": 2192,
	"./country-flags/LA.svg": 2193,
	"./country-flags/LB.svg": 2194,
	"./country-flags/LC.svg": 2195,
	"./country-flags/LK.svg": 2196,
	"./country-flags/LR.svg": 2197,
	"./country-flags/LS.svg": 2198,
	"./country-flags/LT.svg": 2199,
	"./country-flags/LU.svg": 2200,
	"./country-flags/LY.svg": 2201,
	"./country-flags/MA.svg": 2202,
	"./country-flags/MC.svg": 2203,
	"./country-flags/MD.svg": 2204,
	"./country-flags/ME.svg": 2205,
	"./country-flags/MG.svg": 2206,
	"./country-flags/MH.svg": 2207,
	"./country-flags/MK.svg": 2208,
	"./country-flags/ML.svg": 2209,
	"./country-flags/MM.svg": 2210,
	"./country-flags/MN.svg": 2211,
	"./country-flags/MP.svg": 2212,
	"./country-flags/MR.svg": 2213,
	"./country-flags/MS.svg": 2214,
	"./country-flags/MT.svg": 2215,
	"./country-flags/MU.svg": 2216,
	"./country-flags/MV.svg": 2217,
	"./country-flags/MW.svg": 2218,
	"./country-flags/MX.svg": 2219,
	"./country-flags/MY.svg": 2220,
	"./country-flags/MZ.svg": 2221,
	"./country-flags/NA.svg": 2222,
	"./country-flags/NC.svg": 2223,
	"./country-flags/NE.svg": 2224,
	"./country-flags/NF.svg": 2225,
	"./country-flags/NG.svg": 2226,
	"./country-flags/NI.svg": 2227,
	"./country-flags/NL.svg": 2228,
	"./country-flags/NO.svg": 2229,
	"./country-flags/NP.svg": 2230,
	"./country-flags/NR.svg": 2231,
	"./country-flags/NU.svg": 2232,
	"./country-flags/NZ.svg": 2233,
	"./country-flags/OM.svg": 2234,
	"./country-flags/PE.svg": 2235,
	"./country-flags/PF.svg": 2236,
	"./country-flags/PG.svg": 2237,
	"./country-flags/PH.svg": 2238,
	"./country-flags/PK.svg": 2239,
	"./country-flags/PL.svg": 2240,
	"./country-flags/PM.svg": 2241,
	"./country-flags/PR.svg": 2242,
	"./country-flags/PS.svg": 2243,
	"./country-flags/PT.svg": 2244,
	"./country-flags/PW.svg": 2245,
	"./country-flags/PY.svg": 2246,
	"./country-flags/QA.svg": 2247,
	"./country-flags/RO.svg": 2248,
	"./country-flags/RS.svg": 2249,
	"./country-flags/RU.svg": 2250,
	"./country-flags/RW.svg": 2251,
	"./country-flags/SA.svg": 2252,
	"./country-flags/SB.svg": 2253,
	"./country-flags/SC.svg": 2254,
	"./country-flags/SD.svg": 2255,
	"./country-flags/SE.svg": 2256,
	"./country-flags/SG.svg": 2257,
	"./country-flags/SI.svg": 2258,
	"./country-flags/SJ.svg": 2259,
	"./country-flags/SK.svg": 2260,
	"./country-flags/SL.svg": 2261,
	"./country-flags/SM.svg": 2262,
	"./country-flags/SN.svg": 2263,
	"./country-flags/SO.svg": 2264,
	"./country-flags/SR.svg": 2265,
	"./country-flags/ST.svg": 2266,
	"./country-flags/SV.svg": 2267,
	"./country-flags/SY.svg": 2268,
	"./country-flags/SZ.svg": 2269,
	"./country-flags/TC.svg": 2270,
	"./country-flags/TD.svg": 2271,
	"./country-flags/TG.svg": 2272,
	"./country-flags/TH.svg": 2273,
	"./country-flags/TJ.svg": 2274,
	"./country-flags/TK.svg": 2275,
	"./country-flags/TM.svg": 2276,
	"./country-flags/TN.svg": 2277,
	"./country-flags/TO.svg": 2278,
	"./country-flags/TT.svg": 2279,
	"./country-flags/TV.svg": 2280,
	"./country-flags/TW.svg": 2281,
	"./country-flags/TZ.svg": 2282,
	"./country-flags/UA.svg": 2283,
	"./country-flags/UG.svg": 2284,
	"./country-flags/UY.svg": 2285,
	"./country-flags/UZ.svg": 2286,
	"./country-flags/VC.svg": 2287,
	"./country-flags/VE.svg": 2288,
	"./country-flags/VN.svg": 2289,
	"./country-flags/VU.svg": 2290,
	"./country-flags/WF.svg": 2291,
	"./country-flags/WS.svg": 2292,
	"./country-flags/YE.svg": 2293,
	"./country-flags/YT.svg": 2294,
	"./country-flags/ZA.svg": 2295,
	"./country-flags/ZM.svg": 2296,
	"./country-flags/ZW.svg": 2297,
	"./country-flags/_abkhazia.svg": 2298,
	"./country-flags/_aland-islands.svg": 2299,
	"./country-flags/_albania.svg": 2300,
	"./country-flags/_azores-islands.svg": 2301,
	"./country-flags/_balearic-islands.svg": 2302,
	"./country-flags/_basque-country.svg": 2303,
	"./country-flags/_bhutan-1.svg": 2304,
	"./country-flags/_bonaire.svg": 2305,
	"./country-flags/_british-columbia.svg": 2306,
	"./country-flags/_british-virgin-islands.svg": 2307,
	"./country-flags/_canary-islands.svg": 2308,
	"./country-flags/_ceuta.svg": 2309,
	"./country-flags/_china.svg": 2310,
	"./country-flags/_corsica.svg": 2311,
	"./country-flags/_croatia.svg": 2312,
	"./country-flags/_curacao.svg": 2313,
	"./country-flags/_cyprus.svg": 2314,
	"./country-flags/_democratic-republic-of-congo.svg": 2315,
	"./country-flags/_denmark.svg": 2316,
	"./country-flags/_east-timor.svg": 2317,
	"./country-flags/_england.svg": 2318,
	"./country-flags/_ethiopia.svg": 2319,
	"./country-flags/_european-union.svg": 2320,
	"./country-flags/_france.svg": 2321,
	"./country-flags/_galapagos-islands.svg": 2322,
	"./country-flags/_georgia.svg": 2323,
	"./country-flags/_gibraltar.svg": 2324,
	"./country-flags/_greece.svg": 2325,
	"./country-flags/_guernsey.svg": 2326,
	"./country-flags/_hawaii.svg": 2327,
	"./country-flags/_hong-kong.svg": 2328,
	"./country-flags/_isle-of-man.svg": 2329,
	"./country-flags/_ivory-coast.svg": 2330,
	"./country-flags/_jersey.svg": 2331,
	"./country-flags/_kosovo.svg": 2332,
	"./country-flags/_latvia.svg": 2333,
	"./country-flags/_liechtenstein.svg": 2334,
	"./country-flags/_macao.svg": 2335,
	"./country-flags/_madeira.svg": 2336,
	"./country-flags/_martinique.svg": 2337,
	"./country-flags/_melilla.svg": 2338,
	"./country-flags/_moldova.svg": 2339,
	"./country-flags/_nato.svg": 2340,
	"./country-flags/_northen-cyprus.svg": 2341,
	"./country-flags/_orkney-islands.svg": 2342,
	"./country-flags/_ossetia.svg": 2343,
	"./country-flags/_panama.svg": 2344,
	"./country-flags/_pitcairn-islands.svg": 2345,
	"./country-flags/_rapa-nui.svg": 2346,
	"./country-flags/_saba-island.svg": 2347,
	"./country-flags/_sardinia.svg": 2348,
	"./country-flags/_scotland.svg": 2349,
	"./country-flags/_sint-eustatius.svg": 2350,
	"./country-flags/_sint-maarten.svg": 2351,
	"./country-flags/_somaliland.svg": 2352,
	"./country-flags/_south-sudan.svg": 2353,
	"./country-flags/_st-barts.svg": 2354,
	"./country-flags/_switzerland.svg": 2355,
	"./country-flags/_tibet.svg": 2356,
	"./country-flags/_transnistria.svg": 2357,
	"./country-flags/_turkey.svg": 2358,
	"./country-flags/_united-nations.svg": 2359,
	"./country-flags/_united-states-of-america.svg": 2360,
	"./country-flags/_vatican-city.svg": 2361,
	"./country-flags/_virgin-islands.svg": 2362,
	"./country-flags/_wales.svg": 2363,
	"./country-flags/country-flag-sprite.svg": 472,
	"./country-flags/lc.svg": 2364,
	"./currencies/EUR.svg": 2365,
	"./currencies/KGS.svg": 2366,
	"./currencies/KZT.svg": 2367,
	"./currencies/OPX.svg": 2368,
	"./currencies/RUR.svg": 2369,
	"./currencies/USD.svg": 2370,
	"./currencies/currencies-flag-sprite.svg": 841,
	"./dark-add.svg": 2371,
	"./dark-clear-betslip.svg": 2372,
	"./dark-hide-betslips.svg": 2373,
	"./dark-important.svg": 842,
	"./drop-down-icon.png": 2374,
	"./drop-up-icon.png": 2375,
	"./envelope.svg": 930,
	"./eye-off.svg": 843,
	"./eye.svg": 287,
	"./fairplay-logo.svg": 844,
	"./favicon.png": 2376,
	"./favicon@2x.png": 2377,
	"./feed_beachvolleyball.png": 2378,
	"./feed_billiards.png": 2379,
	"./feed_shuttlecock.png": 2380,
	"./feed_tabletennis.png": 2381,
	"./feed_tennis.png": 2382,
	"./feed_volleyball.png": 2383,
	"./finish.svg": 350,
	"./fire.svg": 2384,
	"./flag-en.svg": 845,
	"./flag-kz.svg": 2385,
	"./flag-ru.svg": 846,
	"./flag-uz.svg": 847,
	"./footer/binance.svg": 2386,
	"./footer/bitcoin.svg": 848,
	"./footer/bnb.svg": 849,
	"./footer/busd.png": 2387,
	"./footer/busd.svg": 850,
	"./footer/dash.svg": 851,
	"./footer/ethereum.svg": 852,
	"./footer/ethereumNew.jpg": 2388,
	"./footer/litecoin-color.svg": 2389,
	"./footer/litecoin.svg": 853,
	"./footer/mastercard-color.svg": 854,
	"./footer/mastercard.svg": 855,
	"./footer/opex.svg": 856,
	"./footer/solana.svg": 857,
	"./footer/tron.svg": 858,
	"./footer/usdc-color.svg": 2390,
	"./footer/usdc.svg": 859,
	"./footer/usdt-color.svg": 2391,
	"./footer/usdt.svg": 262,
	"./footer/visa-color.svg": 860,
	"./footer/visa.svg": 861,
	"./fp-logo.svg": 484,
	"./freebet.png": 2392,
	"./games/baccarat.png": 2393,
	"./games/black-jack.png": 2394,
	"./games/fastsport.jpg": 2395,
	"./games/favorite.png": 823,
	"./games/filter.svg": 811,
	"./games/filterIcon.png": 2396,
	"./games/hollywood.png": 2397,
	"./games/home-black.png": 2398,
	"./games/home-opacity.png": 2399,
	"./games/home.png": 824,
	"./games/jacktop.jpg": 2400,
	"./games/leap-gaming.jpg": 2401,
	"./games/leftArrowIcon.png": 813,
	"./games/pocker.png": 2402,
	"./games/recent.png": 825,
	"./games/red-rake.jpg": 2403,
	"./games/resetIcon.png": 2404,
	"./games/roulette.png": 2405,
	"./games/searchIcon.png": 2406,
	"./games/slots.jpg": 2407,
	"./games/tvbet-roullette.png": 2408,
	"./games/tvbet.jpg": 2409,
	"./games/virtual_sports.jpg": 2410,
	"./games/vivo.png": 2411,
	"./games/xpress-favorite-game.svg": 814,
	"./games/xpress-non-favorite-game.svg": 815,
	"./games/xpressGames.jpg": 2412,
	"./hide icon.svg": 288,
	"./hide-betslips.svg": 2413,
	"./hint.svg": 473,
	"./history-calendar.svg": 862,
	"./icon-arrow-down-dark.svg": 474,
	"./icon-arrow-down-light.svg": 475,
	"./icon-calendar.svg": 863,
	"./icon-copy.svg": 431,
	"./icon-left.svg": 864,
	"./icon-top.svg": 865,
	"./icon_accept.svg": 866,
	"./icon_back.svg": 2414,
	"./icon_dayNormal.svg": 2415,
	"./icon_daySelected.svg": 2416,
	"./icon_lock.svg": 2417,
	"./icon_locklight.svg": 867,
	"./icon_nightNormal.svg": 2418,
	"./icon_nightSelected.svg": 2419,
	"./icon_remove.svg": 2420,
	"./icon_removelight.svg": 868,
	"./icon_search.svg": 2421,
	"./icon_themeAuto.svg": 869,
	"./icon_top.svg": 2422,
	"./icon_top_dark.svg": 870,
	"./icon_wait.svg": 871,
	"./icons/all-fp-dark-old.svg": 352,
	"./icons/all-fp-dark.svg": 353,
	"./icons/all-fp.svg": 354,
	"./icons/all.svg": 355,
	"./icons/americanfootball.svg": 356,
	"./icons/athletics.svg": 357,
	"./icons/badminton.svg": 358,
	"./icons/bandy.svg": 359,
	"./icons/baseball.svg": 360,
	"./icons/basketball.svg": 361,
	"./icons/beachsoccer.svg": 362,
	"./icons/beachvolley.svg": 363,
	"./icons/bet-games.svg": 364,
	"./icons/biathlon.svg": 365,
	"./icons/bowling.svg": 366,
	"./icons/box.svg": 367,
	"./icons/calendar.svg": 238,
	"./icons/chess.svg": 368,
	"./icons/copy.png": 464,
	"./icons/culture.svg": 369,
	"./icons/cybersports.svg": 370,
	"./icons/cycling.svg": 371,
	"./icons/darts.svg": 372,
	"./icons/election.svg": 373,
	"./icons/fastsport_icon.svg": 374,
	"./icons/fieldhockey.svg": 375,
	"./icons/floorball.svg": 376,
	"./icons/formula1.svg": 377,
	"./icons/futsal.svg": 378,
	"./icons/games.svg": 379,
	"./icons/golf.svg": 380,
	"./icons/handball.svg": 381,
	"./icons/hockeygras.svg": 382,
	"./icons/icehockey.svg": 383,
	"./icons/icon-massege-error.png": 872,
	"./icons/icon-successful-payment.png": 435,
	"./icons/info-alert.svg": 239,
	"./icons/info-icon.svg": 240,
	"./icons/innopay.svg": 384,
	"./icons/innopayD.svg": 385,
	"./icons/key-icon.svg": 241,
	"./icons/keyhole.svg": 242,
	"./icons/kvn.svg": 386,
	"./icons/logo.svg": 387,
	"./icons/lottery.svg": 388,
	"./icons/olimpicgames.svg": 389,
	"./icons/opex-active.png": 873,
	"./icons/opex.png": 874,
	"./icons/opex.svg": 390,
	"./icons/opexD.svg": 391,
	"./icons/pocker.svg": 392,
	"./icons/pool.svg": 393,
	"./icons/qiwi.svg": 394,
	"./icons/qiwiD.svg": 395,
	"./icons/rugby.svg": 396,
	"./icons/skiing.svg": 397,
	"./icons/soccer.svg": 398,
	"./icons/stream.svg": 236,
	"./icons/success.svg": 243,
	"./icons/swimming.svg": 399,
	"./icons/tabletennislive.svg": 400,
	"./icons/tennis.svg": 401,
	"./icons/total.svg": 402,
	"./icons/tracker.svg": 237,
	"./icons/ttennis.svg": 403,
	"./icons/visa-active.png": 875,
	"./icons/visa.png": 876,
	"./icons/volley.svg": 404,
	"./icons/waterpolo.svg": 405,
	"./icons/weather.svg": 406,
	"./icons/whatwherewhen.svg": 407,
	"./icons/wrestling.svg": 408,
	"./id-card-front.svg": 2423,
	"./important.svg": 85,
	"./instagram_dark.svg": 2424,
	"./instagram_logo.svg": 476,
	"./loading-1.svg": 86,
	"./loading-2.svg": 87,
	"./loading-3.svg": 88,
	"./loading.gif": 196,
	"./logo.png": 2425,
	"./logo@2x.png": 2426,
	"./match-arrow-right.svg": 477,
	"./menu-icon.svg": 877,
	"./mobile.png": 2427,
	"./money_training.svg": 2428,
	"./moon.svg": 878,
	"./navi_datapicker.png": 879,
	"./noprofile.svg": 2429,
	"./not-checked.svg": 289,
	"./opex-instruction-logo.svg": 2430,
	"./pause_stream_img.svg": 661,
	"./pay/logo_skrill_s.png": 2431,
	"./pay/logo_wooppay.png": 2432,
	"./pay/logo_wooppay_s.png": 2433,
	"./pay/opex.png": 2434,
	"./pay/p_demirbank.png": 2435,
	"./pay/p_geopay.png": 2436,
	"./pay/p_megapay.png": 2437,
	"./pay/p_mobilnik.png": 2438,
	"./pay/p_qiwi.png": 2439,
	"./pay/p_quickpay.png": 2440,
	"./pay/p_webmoney.png": 2441,
	"./pay/s_geopay.png": 2442,
	"./pay/s_megapay.png": 2443,
	"./pay/s_mobilnik.png": 2444,
	"./pay/s_qiwi.png": 2445,
	"./pay/s_quickpay.png": 2446,
	"./pay/s_visa.png": 2447,
	"./payment/ethereumNew.svg": 2448,
	"./payment/kz_pay/activ.svg": 880,
	"./payment/kz_pay/altel.svg": 881,
	"./payment/kz_pay/apple-pay.svg": 882,
	"./payment/kz_pay/beeline.svg": 883,
	"./payment/kz_pay/google-pay.svg": 884,
	"./payment/kz_pay/halyk.svg": 885,
	"./payment/kz_pay/kcell.svg": 886,
	"./payment/kz_pay/qiwi.svg": 887,
	"./payment/kz_pay/tele2.svg": 888,
	"./payment/kz_pay/visa-mastercard.svg": 889,
	"./payment/kz_pay/woopay-wallet.svg": 890,
	"./payment/networks/bep20.svg": 429,
	"./payment/networks/etherium.svg": 428,
	"./payment/networks/polygon-matic-logo.png": 430,
	"./payment/networks/tron.svg": 427,
	"./payment/usdt.svg": 189,
	"./payment/visa.svg": 891,
	"./pin_img.svg": 660,
	"./play_stream_img.svg": 659,
	"./polygon_1.svg": 892,
	"./promos-banner/mobile-promos-banner_1.jpg": 2449,
	"./promos-banner/mobile-promos-banner_2.jpg": 2450,
	"./promos-banner/mobile-promos-banner_3.jpg": 2451,
	"./qiwi.png": 2452,
	"./question-icon.png": 2453,
	"./rate-down.svg": 893,
	"./rate-up.svg": 894,
	"./refresh.svg": 895,
	"./screen.svg": 896,
	"./screenshot.svg": 931,
	"./section-arrow-right.svg": 478,
	"./select.png": 897,
	"./select.svg": 479,
	"./settings.svg": 898,
	"./show icon.svg": 899,
	"./slider-banners/cybersport/left.png": 2454,
	"./slider-banners/cybersport/right.png": 2455,
	"./slider-banners/double-win/double-win.png": 2456,
	"./slider-banners/fast-sport/fast-sportBg.png": 900,
	"./slider-banners/fast-sport/fast-sportLeft.svg": 2457,
	"./slider-banners/fast-sport/fast-sportRight.svg": 2458,
	"./slider-banners/fast-sport/fast-sportTextEN.svg": 2459,
	"./slider-banners/fast-sport/fast-sportTextRU.svg": 2460,
	"./slider-banners/instagram-promo/dialog.png": 901,
	"./slider-banners/instagram-promo/iphone15promax.png": 2461,
	"./slider-banners/instagram-promo/iphones.png": 2462,
	"./slider-banners/instagram-promo/megafon.png": 2463,
	"./slider-banners/instagram-promo/money.png": 2464,
	"./slider-banners/jacktop-games/jacktop-banner-girl.png": 902,
	"./slider-banners/jacktop-games/jacktop-banner-logo.png": 903,
	"./slider-banners/jacktop-games/jacktop-games-Bg.png": 904,
	"./slider-banners/jacktop-games/live-casino-games-en.png": 905,
	"./slider-banners/jacktop-games/live-casino-games-ru.png": 906,
	"./slider-banners/jacktop-games/try-new-en.png": 907,
	"./slider-banners/jacktop-games/try-new-ru.png": 908,
	"./slider-banners/lucky-chiken/bg.png": 909,
	"./slider-banners/lucky-chiken/btn-en.png": 2465,
	"./slider-banners/lucky-chiken/btn-ru.png": 2466,
	"./slider-banners/lucky-chiken/logo.png": 2467,
	"./slider-banners/lucky-chiken/mid.png": 2468,
	"./slider-banners/lucky-chiken/text-en.png": 2469,
	"./slider-banners/lucky-chiken/text-ru.png": 2470,
	"./slider-banners/summer-bum/summer-bum-bg.png": 910,
	"./slider-banners/summer-bum/summer-bum-text-en.svg": 2471,
	"./slider-banners/summer-bum/summer-bum-text-ru.svg": 2472,
	"./slider-banners/vivo/vivo-banner-bg.png": 911,
	"./slider-banners/vivo/vivo-banner-girl.png": 912,
	"./slider-banners/welcome-bonus/fire.svg": 2473,
	"./sms.png": 913,
	"./soccer_ball.png": 467,
	"./sport-back-history.svg": 480,
	"./sport-back.svg": 481,
	"./sprite.png": 914,
	"./stream-play_img.svg": 915,
	"./stream_display_img.jpg": 2474,
	"./telegram.svg": 2475,
	"./tick.svg": 831,
	"./tv_black.png": 916,
	"./tv_white.png": 2476,
	"./unpin_img.svg": 662,
	"./user.png": 2477,
	"./user.svg": 917,
	"./userpic.svg": 918,
	"./warning-circle.svg": 2478,
	"./whatsapp.svg": 919,
	"./windjammer_bg.png": 2479,
	"./windjammer_bg2x.png": 2480,
	"./windjammer_logo.png": 2481,
	"./windjammer_logo2x.png": 2482,
	"./withdraw-bottom-white.png": 920,
	"./withdraw-bottom.png": 2483,
	"./withdraw-top-white.png": 921,
	"./withdraw-top.png": 2484
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 199;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = 199
// module chunks = 7